import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-eye",
  templateUrl: "./eye.component.html",
  styleUrls: ["./eye.component.scss"],
})
export class EyeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
